const c = {
  name: "Graph",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36.5,0C34.6,0,33,1.6,33,3.5C33,4,33.1,4.6,33.3,5l-6,5.5c-0.5-0.3-1.1-0.5-1.8-0.5c-1.2,0-2.2,0.6-2.8,1.4
			L18,9.7c0-0.1,0-0.1,0-0.2C18,7.6,16.4,6,14.5,6c-1.4,0-2.5,0.8-3.1,1.9L7,7.1C6.8,5.4,5.3,4,3.5,4C1.6,4,0,5.6,0,7.5
			C0,9.4,1.6,11,3.5,11c1.4,0,2.5-0.8,3.1-1.9L11,9.9c0.2,1.8,1.7,3.1,3.5,3.1c1.2,0,2.2-0.6,2.8-1.4l4.7,1.7c0,0.1,0,0.1,0,0.2
			c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5c0-0.5-0.1-1.1-0.3-1.5l6-5.5C35.2,6.8,35.8,7,36.5,7C38.4,7,40,5.4,40,3.5
			C40,1.6,38.4,0,36.5,0z M35,3.5C35,2.7,35.7,2,36.5,2C37.3,2,38,2.7,38,3.5C38,4.3,37.3,5,36.5,5C35.7,5,35,4.3,35,3.5z M3.5,6
			C4.3,6,5,6.7,5,7.5C5,8.3,4.3,9,3.5,9S2,8.3,2,7.5C2,6.7,2.7,6,3.5,6z M13,9.5C13,8.7,13.7,8,14.5,8C15.3,8,16,8.7,16,9.5
			c0,0.8-0.7,1.5-1.5,1.5C13.7,11,13,10.3,13,9.5z M25.5,12c0.8,0,1.5,0.7,1.5,1.5S26.3,15,25.5,15S24,14.3,24,13.5S24.7,12,25.5,12
			z"/>
		<path class="st0" d="M33,20.5c0,0.2,0,0.3,0,0.5l-4.9,2.2c-0.6-0.7-1.6-1.2-2.6-1.2c-1.9,0-3.5,1.6-3.5,3.5c0,0.6,0.2,1.2,0.4,1.7
			l-6.3,6.3c-0.5-0.3-1.1-0.4-1.7-0.4c-1,0-1.8,0.4-2.5,1l-5.1-2.8C7,31,7,30.8,7,30.5C7,28.6,5.4,27,3.5,27S0,28.6,0,30.5
			S1.6,34,3.5,34c1,0,1.8-0.4,2.5-1l5.1,2.8c0,0.2-0.1,0.5-0.1,0.7c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5c0-0.6-0.2-1.2-0.4-1.7
			l6.3-6.3c0.5,0.3,1.1,0.4,1.7,0.4c1.9,0,3.5-1.6,3.5-3.5c0-0.2,0-0.3,0-0.5l4.9-2.2c0.6,0.7,1.6,1.2,2.6,1.2
			c1.9,0,3.5-1.6,3.5-3.5S38.4,17,36.5,17C34.6,17,33,18.6,33,20.5z M2,30.5C2,29.7,2.7,29,3.5,29S5,29.7,5,30.5
			C5,31.3,4.3,32,3.5,32S2,31.3,2,30.5z M14.5,35c0.8,0,1.5,0.7,1.5,1.5S15.3,38,14.5,38c-0.8,0-1.5-0.7-1.5-1.5S13.7,35,14.5,35z
			 M24,25.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5S24,26.3,24,25.5z M36.5,19c0.8,0,1.5,0.7,1.5,1.5
			c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5C35,19.7,35.7,19,36.5,19z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Graph
};
